import { render, staticRenderFns } from "./AgreementNewsModal.vue?vue&type=template&id=54c84331&scoped=true"
import script from "./AgreementNewsModal.vue?vue&type=script&lang=js"
export * from "./AgreementNewsModal.vue?vue&type=script&lang=js"
import style0 from "./AgreementNewsModal.vue?vue&type=style&index=0&id=54c84331&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c84331",
  null
  
)

export default component.exports